import { gql, useMutation } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

const SUBMIT_WEBSITE_URL = gql`
  mutation SubmitWebsiteUrl($input: SubmitWebsiteUrlInput!, $token: String) {
    submitWebsiteUrl(input: $input, token: $token) {
      url
      propertyId
      status
      scanFinished
      progressCurrent
      progressTotal
    }
  }
`;

export interface QuestionnaireWebsiteScan {
  url: string | null;
  propertyId: string | null;
  status: string;
  scanFinished: boolean;
  progressCurrent: number | null;
  progressTotal: number | null;
}

export interface SubmitWebsiteUrlData {
  submitWebsiteUrl: QuestionnaireWebsiteScan;
}

export interface SubmitWebsiteUrlVariables {
  input: { url: string };
  token?: string | null;
}

export function useSubmitWebsiteUrlMutation() {
  const { token } = useShareTokenJwt();
  const [mutate, result] = useMutation<SubmitWebsiteUrlData, SubmitWebsiteUrlVariables>(SUBMIT_WEBSITE_URL, {
    refetchQueries: ['QuestionnaireWebsiteScan'],
  });
  const wrapped: typeof mutate = (options) =>
    mutate({ ...options, variables: { ...(options?.variables as SubmitWebsiteUrlVariables), token } });
  return [wrapped, result] as const;
}
